<div [ngStyle]="{'height': (layoutService.usableContentHeight() - scrollHeightOffset) > minScrollHeight ? (layoutService.usableContentHeight() - scrollHeightOffset)  + 'px' : minScrollHeight + 'px'}">
  @if (initialized && !refreshControls) {
    <p-table #dataTable
             [loading]="dataLoading"
             loadingIcon="pi pi-spinner"
             [showLoader]="false"
             [value]="model"
             [dataKey]="tableConfig?.dataKey"
             [lazy]="tableConfig?.lazyLoading"
             [lazyLoadOnInit]="tableConfig?.lazyLoading"
             [first]="first"
             [rows]="rows ? rows : tableConfig?.rows"
             [rowsPerPageOptions]="tableConfig?.rowsPerPageOptions"
             [totalRecords]="totalRecords"
             [selectionMode]="tableConfig?.selectionMode"
             [(selection)]="selectedRowsData"
             [metaKeySelection]="true"
             [stateKey]="tableConfig.saveState ? tableConfig.sessionName : null"
             stateStorage="session"
             [scrollable]="tableConfig?.scrollable"
             [paginator]="paginator"
             [showJumpToPageDropdown]="tableConfig?.showJumpToPage"
             [sortField]="tableConfig?.sortField"
             [sortOrder]="tableConfig?.sortOrder"
             [size]="tableConfig?.size"
             scrollHeight="flex"
             [stripedRows]="tableConfig?.stripedRows"
             [showGridlines]="tableConfig?.showGridLines"
             [columns]="visibleColumns"
             [currentPageReportTemplate]="i18n?.i18nLng()['TABLEPAGETEMPLATE']"
             [showCurrentPageReport]="false"
             [filterDelay]="300"
             (onLazyLoad)="getTablePageData($event)"
             (onRowSelect)="onRowSelect($event)"
             (onRowUnselect)="onRowUnselect($event)"
             (rowsChange)="rowsCountChanged.emit($event)"
             (onFilter)="onFilter($event)"
             (onSort)="onSort($event)"
             (onStateRestore)="onStateRestore($event)">

      <ng-template pTemplate="header" let-columns>
        <!-- Header row
             ========== -->
        <tr>
          @for (col of columns; track col.columnName) {
            <th [pSortableColumn]="col.columnName"
                [pSortableColumnDisabled]="!col.sortable"
                [pTooltip]="tableConfig?.i18nMode && col?.headerTooltip ? i18n.i18nLng()[col.headerTooltip] : col?.headerTooltip"
                tooltipPosition="top"
                [frozen]="col?.frozen && freezeColumns"
                pFrozenColumn
                alignFrozen="left"
                [ngClass]="col?.lastFrozenColumn ? 'last-frozen-column' : null"
                [ngStyle]="{'min-width': col.minWidth, 'max-width': col?.maxWidth ? col.maxWidth : '100%', 'text-align': col?.headerAlign ? col?.headerAlign : 'left', 'word-break': 'break-all'}">
              @switch (col?.headerType) {
                @case (ColumnHeaderType.ICON) {
                  <i [class]="col.headerIcon" [ngClass]="col?.headerIconClass ? col?.headerIconClass : null"></i>
                }
                @case (ColumnHeaderType.ICONTEXT) {
                  <div class="inline-flex align-items-center">
                    <i [class]="col.headerIcon + ' mr-2'" [ngClass]="col?.headerIconClass ? col?.headerIconClass : null"></i>
                    <span [ngClass]="col?.headerTextClass ? col?.headerTextClass : null">{{ tableConfig?.i18nMode && col?.headerText ? i18n?.i18nLng()[col?.headerText] : col?.headerText }}</span>
                  </div>
                }
                @case (ColumnHeaderType.TEXTICON) {
                  <div class="inline-flex align-items-center">
                    <span class="mr-2" [ngClass]="col?.headerTextClass ? col?.headerTextClass : null">{{ tableConfig?.i18nMode && col?.headerText ? i18n?.i18nLng()[col?.headerText] : col?.headerText }}</span>
                    <i [class]="col.headerIcon" [ngClass]="col?.headerIconClass ? col?.headerIconClass : null"></i>
                  </div>
                }
                @default {
                  <ng-container [ngClass]="col?.headerTextClass ? col?.headerTextClass : null">{{ tableConfig?.i18nMode && col?.headerText ? i18n?.i18nLng()[col?.headerText] : col?.headerText }}</ng-container>
                }
              }
              @if (col.sortable) {
                <p-sortIcon [field]="col.columnName"></p-sortIcon>
              }
            </th>
          }
          @if (showTogglerIcon) {
            <th></th>
          }
        </tr>

        <!-- Filter rows
             ======================== -->
        @if (tableConfig?.showFilters) {
          <ng-container>
            <tr>
              @for (col of columns; track col.columnName) {
                <th [frozen]="col?.frozen && freezeColumns"
                    pFrozenColumn
                    alignFrozen="left"
                    [ngClass]="col?.lastFrozenColumn ? 'last-frozen-column' : null"
                    [ngStyle]="{'min-width': col.minWidth, 'max-width': col?.maxWidth ? col.maxWidth : '100%','text-align': col?.filterAlign ? col?.filterAlign : 'left'}">
                  <p-fluid>
                    @switch (col?.filterType) {
                      @case (ColumnFilterType.TEXT) {
                        <p-columnFilter type="text"
                                        [style]=""
                                        [field]="col?.columnName"
                                        [matchMode]="col?.filterMatchMode ? col?.filterMatchMode : 'contains'"
                                        [showMenu]="col?.filterMenu"
                                        [matchModeOptions]="col?.onlyStartsWithMatchMode ? startsWithMatchMode : null"
                                        [placeholder]="tableConfig.i18nMode && col?.filterPlaceholder ? i18n.i18nLng()[col.filterPlaceholder] : col?.filterPlaceholder"
                                        filterOn="input"
                                        [pTooltip]="tableConfig.i18nMode && col?.filterPlaceholder ? i18n.i18nLng()[col.filterPlaceholder] : col?.filterPlaceholder"
                                        tooltipPosition="bottom"
                                        [attr.aria-label]="'Filter ' + col?.headerText">
                        </p-columnFilter>
                      }
                      @case (ColumnFilterType.DATE) {
                        <p-columnFilter type="date"
                                        [field]="col?.columnName"
                                        [matchMode]="col?.filterMatchMode ? col?.filterMatchMode : 'equals'"
                                        [showMenu]="col?.filterMenu"
                                        [showMatchModes]="false"
                                        [placeholder]="tableConfig.i18nMode && col?.filterPlaceholder ? i18n.i18nLng()[col.filterPlaceholder] : col?.filterPlaceholder"
                                        [attr.aria-label]="'Filter ' + col?.headerText">
                        </p-columnFilter>
                      }
                      @case (ColumnFilterType.NUMBER) {
                        <!--
                        <p-columnFilter type="numeric"
                                        [field]="col?.columnName"
                                        [matchMode]="col?.filterMatchMode ? col?.filterMatchMode : 'equals'"
                                        [showMenu]="col?.filterMenu"
                                        [placeholder]="tableConfig.i18nMode && col?.filterPlaceholder ? i18n.i18nLng()[col.filterPlaceholder] : col?.filterPlaceholder"
                                        filterOn="input"
                                        [pTooltip]="tableConfig.i18nMode && col?.filterPlaceholder ? i18n.i18nLng()[col.filterPlaceholder] : col?.filterPlaceholder"
                                        tooltipPosition="bottom"
                                        [attr.aria-label]="'Filter ' + col?.headerText">
                        </p-columnFilter>
                        -->
                        <p-columnFilter type="numeric"
                                        [field]="col?.columnName"
                                        [matchMode]="col?.filterMatchMode ? col?.filterMatchMode : 'equals'"
                                        [showMenu]="col?.filterMenu"
                                        filterOn="input">
                          <ng-template pTemplate="filter" let-value let-filterCallback="filterCallback">
                            <p-inputNumber [ngModel]="value"
                                           [placeholder]="tableConfig.i18nMode && col?.filterPlaceholder ? i18n.i18nLng()[col.filterPlaceholder] : col?.filterPlaceholder"
                                           (ngModelChange)="filterCallback($event)"
                                           [min]="0"
                                           [showButtons]="true"
                                           class="w-full"
                                           [pTooltip]="tableConfig.i18nMode && col?.filterPlaceholder ? i18n.i18nLng()[col.filterPlaceholder] : col?.filterPlaceholder"
                                           tooltipPosition="bottom"
                                           [attr.aria-label]="'Filter ' + col?.headerText">>
                            </p-inputNumber>
                          </ng-template>
                        </p-columnFilter>
                      }
                      @case (ColumnFilterType.TEXTUPPERCASE) {
                        <p-columnFilter [field]="col?.columnName"
                                        [matchMode]="col?.filterMatchMode ? col?.filterMatchMode : 'equals'"
                                        [showMenu]="col?.filterMenu"
                                        [placeholder]="col?.filterPlaceholder ? col?.filterPlaceholder : undefined"
                                        [pTooltip]="tableConfig.i18nMode && col?.filterPlaceholder ? i18n.i18nLng()[col.filterPlaceholder] : col?.filterPlaceholder"
                                        tooltipPosition="bottom"
                                        [attr.aria-label]="'Filter ' + col?.headerText">
                          <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                            <input pInputText
                                   [ngClass]="value && value.length > 0 ? 'uppercase' : null"
                                   fluid
                                   [ngModel]="value"
                                   (input)="filter($event.target.value)"
                                   [placeholder]="tableConfig.i18nMode && col?.filterPlaceholder ? i18n.i18nLng()[col.filterPlaceholder] : col?.filterPlaceholder"/>
                          </ng-template>
                        </p-columnFilter>
                      }
                      @case (ColumnFilterType.CURRENCY) {
                        <p-columnFilter [field]="col?.columnName"
                                        [matchMode]="col?.filterMatchMode ? col?.filterMatchMode : 'equals'"
                                        [showMenu]="col?.filterMenu"
                                        [matchModeOptions]="startsWithMatchMode"
                                        [placeholder]="col?.filterPlaceholder ? col?.filterPlaceholder : undefined"
                                        [pTooltip]="tableConfig.i18nMode && col?.filterPlaceholder ? i18n.i18nLng()[col.filterPlaceholder] : col?.filterPlaceholder"
                                        tooltipPosition="bottom"
                                        [attr.aria-label]="'Filter ' + col?.headerText">
                          <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                            <p-input-number [ngModel]="value"
                                            fluid
                                            mode="decimal"
                                            [minFractionDigits]="2"
                                            [maxFractionDigits]="2"
                                            [placeholder]="tableConfig.i18nMode && col?.filterPlaceholder ? i18n.i18nLng()[col.filterPlaceholder] : col?.filterPlaceholder"
                                            (onInput)="filter($event.value)">
                            </p-input-number>
                          </ng-template>
                        </p-columnFilter>
                      }
                      @case (ColumnFilterType.CHECK) {
                        <p-columnFilter type="boolean"
                                        [field]="col?.columnName"
                                        [matchMode]="col?.filterMatchMode ? col?.filterMatchMode : 'equals'"
                                        [showMenu]="col?.filterMenu"
                                        [attr.aria-label]="'Filter ' + col?.headerText">
                        </p-columnFilter>
                      }
                      @case (ColumnFilterType.SELECT) {
                        <p-columnFilter [field]="col?.columnName"
                                        [matchMode]="col?.filterMatchMode ? col?.filterMatchMode : 'equals'"
                                        [showMenu]="false"
                                        [attr.aria-label]="'Filter ' + col?.headerText">
                          <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                            <p-select [ngModel]="value"
                                      [options]="tableListProvider.providedLists[col?.selectListKey]"
                                      optionLabel="label"
                                      optionValue="value"
                                      (onChange)="filter($event.value)"
                                      [showClear]="col?.showSelectFilterClear"
                                      [placeholder]="tableConfig.i18nMode && col?.filterPlaceholder ? i18n.i18nLng()[col.filterPlaceholder] : col?.filterPlaceholder"
                                      appendTo="body"
                                      class="w-full">
                              @if (col?.format === ColumnFormat.ICONFROMVALUE) {
                                <ng-template pTemplate="selectedItem" let-selectedOption>
                                  @if (selectedOption.label.startsWith('pi ')) {
                                    <i class="large-icon-cell"
                                       [ngClass]="selectedOption.label"
                                       [pTooltip]="i18n?.i18nLng()[selectedOption.title] ? i18n?.i18nLng()[selectedOption.title] : selectedOption.title"
                                       tooltipPosition="top"
                                       [attr.aria-label]="i18n?.i18nLng()[selectedOption.title] ? i18n?.i18nLng()[selectedOption.title] : selectedOption.title"></i>
                                  } @else {
                                    <sps-custom-icon [name]="selectedOption.label"
                                                     [alt]="selectedOption.title"
                                                     [size]="21"
                                                     [tooltip]="i18n?.i18nLng()[selectedOption.title] ? i18n?.i18nLng()[selectedOption.title] : selectedOption.title">
                                    </sps-custom-icon>
                                  }
                                </ng-template>
                                <ng-template pTemplate="item" let-item>
                                  @if (item.label.startsWith('pi ')) {
                                    <i class="large-icon-cell"
                                       [ngClass]="item.label"
                                       [pTooltip]="i18n?.i18nLng()[item.title] ? i18n?.i18nLng()[item.title] : item.title"
                                       tooltipPosition="top"
                                       [attr.aria-label]="i18n?.i18nLng()[item.name] ? i18n?.i18nLng()[item.name] : item.name"></i>
                                  } @else {
                                    <sps-custom-icon [name]="item.label"
                                                     [alt]="item.name"
                                                     [size]="21"
                                                     [tooltip]="i18n?.i18nLng()[item.title] ? i18n?.i18nLng()[item.title] : item.title">
                                    </sps-custom-icon>
                                  }
                                </ng-template>
                              }
                            </p-select>
                          </ng-template>
                        </p-columnFilter>
                      }
                    }
                  </p-fluid>
                </th>
              }
              @if (showTogglerIcon) {
                <th></th>
              }
            </tr>
          </ng-container>
        }
      </ng-template>

      <!-- Data rows (Body)
           ======================== -->
      <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex">
        <tr [pSelectableRow]="rowData"
            [pSelectableRowIndex]="rowIndex"
            [ngStyle]="{'height': (fixRowHeight !== null && useFixRowHeight) ? (fixRowHeight + 'px') : null}">
          @for (col of visibleColumns; track col.columnName) {
            <td pFrozenColumn
                [frozen]="col?.frozen && freezeColumns" alignFrozen="left"
                [ngClass]="col?.lastFrozenColumn ? 'last-frozen-column' : null"
                [ngStyle]="{'min-width': col.minWidth, 'max-width': col?.maxWidth ? col.maxWidth : '100%', 'text-align': col?.columnAlign ? col?.columnAlign : 'left' }">
              @if (helperService.dataIsDefined(rowData, col.columnName, col?.format)) {
                <ng-container>
                  <ng-container [ngTemplateOutlet]="dataColumns" [ngTemplateOutletContext]="{row: rowData, column: col }"></ng-container>
                </ng-container>
              }
            </td>
          }
          @if (showTogglerIcon) {
            <td class="table-toggler-icon align-items-center" style="width: 28px">
              <i class="pi pi-chevron-right"></i>
            </td>
          }
        </tr>
      </ng-template>

      <!-- Empty-Message
           ======================== -->
      <ng-template pTemplate="emptymessage">
        <tr>
          <td [attr.colspan]="visibleColumns?.length + (showTogglerIcon ? 1 : 0)">
            @if (tableConfig?.i18nMode) {
              <span>{{ tableConfig?.emptyMessage ? i18n.i18nLng()[tableConfig?.emptyMessage] + '...' : i18n.i18nLng()['EMPTYMESSAGE'] + '...' }}</span>
            } @else {
              <span>{{ tableConfig?.emptyMessage ? tableConfig?.emptyMessage : 'Keine Datensätze gefunden...' }}</span>
            }
          </td>
        </tr>
      </ng-template>
    </p-table>
  }
</div>


<!-- Data-Formatting Template
     ======================== -->
<ng-template #dataColumns let-rowData="row" let-col="column">

  @switch (col?.format) {
    @case (ColumnFormat.DATE) {
      <div [ngClass]="col?.columnClass ? col?.columnClass : null">
          {{ helperService.isValidDate(rowData[col.columnName]) ? (rowData[col.columnName] | date : 'dd.MM.yyyy') : null }}
      </div>
    }
    @case (ColumnFormat.DATETIME) {
      <div [ngClass]="col?.columnClass ? col?.columnClass : null">
        {{ helperService.isValidDate(rowData[col.columnName]) ? (rowData[col.columnName] | date : 'dd.MM.yyyy - HH:mm') : null }}
      </div>
    }
    @case (ColumnFormat.TIME) {
      <div [ngClass]="col?.columnClass ? col?.columnClass : null">
        {{ helperService.isValidDate(rowData[col.columnName]) ? (rowData[col.columnName] | date : 'HH:mm:ss') : null }}
      </div>
    }
    @case (ColumnFormat.AMOUNTEUR) {
      <div [ngClass]="col?.columnClass ? col?.columnClass : null">
        {{ rowData[col.columnName] | amountCurrencyDisplay: 'EUR' : 1 }}
      </div>
    }
    @case (ColumnFormat.CURRENCY) {
      <div [ngClass]="col?.columnClass ? col?.columnClass : null">
        {{ rowData[col.columnName] | amountCurrencyDisplay: rowData['currency'] : 100 }}
      </div>
    }
    @case (ColumnFormat.SELECT) {
      <div [ngClass]="col?.columnClass ? col?.columnClass : null">
        {{ rowData[col.columnName] | selectKeyToValue : col.selectList }}
      </div>
    }
    @case (ColumnFormat.MULTISELECT) {
      <div [ngClass]="col?.columnClass ? col?.columnClass : null">
        <p-scrollPanel #scrpan [style]="{width: '100%', height: col.cellHeight + 'px'}" class="sps-scrollpanel">
          {{ rowData[col.columnName] | multiselectKeysToValue : col.selectList : ',' }}
        </p-scrollPanel>
      </div>
    }
    @case (ColumnFormat.MULTISELECT_ARRAY) {
      <div [ngClass]="col?.columnClass ? col?.columnClass : null">
        <p-scrollPanel #scrpan [style]="{width: '100%', height: col.cellHeight + 'px'}" class="sps-scrollpanel">
          {{ rowData[col.columnName] | multiselectKeyArrayToString : col.selectList }}
        </p-scrollPanel>
      </div>
    }
    @case (ColumnFormat.LENGTH) {
      <div [ngClass]="col?.columnClass ? col?.columnClass : null">
        {{ rowData[col.columnName] | arrayLength }}
      </div>
    }
    @case (ColumnFormat.TEXTAREA) {
      <div class="textarea" [ngClass]="col?.columnClass ? col?.columnClass : null">
        {{ rowData[col.columnName] }}
      </div>
    }
    @case (ColumnFormat.HTML) {
      <div [ngClass]="col?.columnClass ? col?.columnClass : null">
        {{ rowData[col.columnName] | stripHtmlTags }}
      </div>
    }
    @case (ColumnFormat.HTMLVIEW) {
      <div [ngClass]="col?.columnClass ? col?.columnClass : null">
        <p-fluid>
          <p-scrollPanel #scrpan [style]="{width: '100%', height: col.cellHeight + 'px'}" class="sps-scrollpanel">
            <div [innerHTML]="rowData[col.columnName] | safeHtml" style="padding: 0.5em; line-height: 1.5; margin-bottom: 0.75em"></div>
          </p-scrollPanel>
        </p-fluid>
      </div>
    }
    @case (ColumnFormat.CHECK) {
      <div [ngClass]="col?.columnClass ? col?.columnClass : null">
        <p-checkbox (onChange)="onCheckFieldChecked(col.columnName, rowData, $event.checked)" [binary]="true" [(ngModel)]="rowData[col.columnName]" [disabled]="col?.disabled"></p-checkbox>
      </div>
    }
    @case (ColumnFormat.BOOLEAN) {
      <div [ngClass]="col?.columnClass ? col?.columnClass : null">
        {{ rowData[col.columnName] | booleanToYesNo }}
      </div>
    }
    @case (ColumnFormat.ICONFROMVALUE) {
      <div [ngClass]="col?.columnClass ? col?.columnClass : null">
        @if (!rowData['customIcon']) {
          <i [ngClass]="rowData[col.columnName]" [attr.aria-label]="i18n?.i18nLng()[rowData['iconTitle']] ? i18n?.i18nLng()[rowData['iconTitle']] : rowData['iconTitle']"></i>
        } @else {
          <sps-custom-icon [name]="rowData[col.columnName].toLowerCase()" [alt]="rowData['iconTitle']" [size]="21"></sps-custom-icon>
        }
      </div>
    }
    @case (ColumnFormat.STATUS) {
      <div [ngClass]="col?.columnClass ? col?.columnClass : null">
        @switch (rowData[col.columnName]) {
          @case ('successful') {
            <p-tag [value]="i18n.i18nLng()['SUCCESSFUL']" severity="success" icon="pi pi-check"/>
          }
          @case ('canceled') {
            <p-tag [value]="i18n.i18nLng()['NOTSUCCESSFUL']" severity="danger" icon="pi pi-exclamation-triangle"/>
          }
          @case ('initialized') {
            <p-tag [value]="i18n.i18nLng()['INITIALIZED']" severity="secondary" icon="pi pi-plus"/>
          }
        }
      </div>
    }
    @case (ColumnFormat.ORGASTATUS) {
      <div [ngClass]="col?.columnClass ? col?.columnClass : null">
        <p-tag
            [value]="rowData[col.columnName] | organisationStatusTag : 'VALUE'"
            [severity]="rowData[col.columnName] | organisationStatusTag : 'SEVERITY'"
            [icon]="rowData[col.columnName] | organisationStatusTag : 'ICON'"/>
      </div>
    }
    @case (ColumnFormat.CUSTOMERSTATUS) {
      <div [ngClass]="col?.columnClass ? col?.columnClass : null">
        <p-tag
            [value]="rowData[col.columnName] | customerStatusTag : 'VALUE'"
            [severity]="rowData[col.columnName] | customerStatusTag : 'SEVERITY'"
            [icon]="rowData[col.columnName] | customerStatusTag : 'ICON'"/>
      </div>
    }
    @case (ColumnFormat.PAYMENTSTATUS) {
      <div [ngClass]="col?.columnClass ? col?.columnClass : null">
        <sps-payment-status-tag [status]="rowData[col.columnName]"></sps-payment-status-tag>
      </div>
    }
    @case (ColumnFormat.ACTIVATIONSTATUS) {
      <div [ngClass]="col?.columnClass ? col?.columnClass : null">
        <sps-activation-status-tag [active]="rowData[col.columnName]"></sps-activation-status-tag>
      </div>
    }
    @default {
      <div [ngClass]="col?.columnClass ? col?.columnClass : 'break-all'">
        {{ rowData[col.columnName] }}
      </div>
    }
  }
</ng-template>

